import i18next from "i18next";

import { Currency } from "../types/currency";

export const formatCurrency = (value: number, currency = Currency.EUR) => {
  return new Intl.NumberFormat(i18next.language, {
    style: "currency",
    currency,
  }).format(value);
};
